export enum planIds {
  FREE_YEARLY = '1',
  FREE_MONTHLY = '2',
  STARTER_750_YEARLY = '3',
  STARTER_750_MONTHLY = '4',
  STARTER_1500_YEARLY = '5',
  STARTER_1500_MONTHLY = '6',
  PROFESSIONAL_2000_YEARLY = '7',
  PROFESSIONAL_2000_MONTHLY = '8',
  PROFESSIONAL_5000_YEARLY = '9',
  PROFESSIONAL_5000_MONTHLY = '10',
  PROFESSIONAL_10000_YEARLY = '11',
  PROFESSIONAL_10000_MONTHLY = '12',
  TEAM_50000_YEARLY = '13',
  TEAM_50000_MONTHLY = '14',
  TEAM_100000_YEARLY = '15',
  TEAM_100000_MONTHLY = '16',
  COMPANY_100000_YEARLY = '17',
  COMPANY_100000_MONTHLY = '18',
  COMPANY_200000_YEARLY = '19',
  COMPANY_200000_MONTHLY = '20',
}
